import React from "react"
import { useSelector } from "react-redux"

import Images from "assets/images"
import { SilResultSafetyFunction } from "server/models"
import { StoreType } from "client/store"
import { Logo, Input } from "client/components"

import {
    ModelWrapper,
    BlockWrapper,
    Block,
    BlockInputWrapper,
    ModelSil,
} from "client/pages/sil/modelStyled"

import { getSilDeviceTitle, getModelSil } from "client/pages/sil/formulas"
import { BlockContent } from "../styled"


interface ModelProps {
    resultSafetyFunction: SilResultSafetyFunction
}

const Model = ({
    resultSafetyFunction,
}: ModelProps) => {
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const lang = useSelector((state: StoreType) => state.system.lang)

    // important! get the subsystem list from the function!
    const subsystemList = resultSafetyFunction.subsystems || []

    return (
        <BlockContent>
            <ModelWrapper direction="row">
                {
                    subsystemList.map((subsystem) => (
                        <BlockWrapper key={subsystem.id} type="function">
                            <BlockInputWrapper>
                                <Input type="text" value={subsystem.architecture} readOnly />
                                <Input type="text" value={subsystem.name} readOnly />
                            </BlockInputWrapper>

                            {
                                subsystem.blocks.map((block) => ([
                                    <Block
                                        key="block"
                                        title={getSilDeviceTitle(block.projectDevice, moduleList, lang)}
                                    >
                                        <Logo
                                            size={100}
                                            logo={
                                                (block.projectDevice && block.projectDevice.logo)
                                            || (
                                                block.projectDevice && block.projectDevice.qidProductId
                                                    ? Images.qidProductLogo
                                                    : Images.silDeviceLogo
                                            )
                                            }
                                        />
                                    </Block>,
                                    <ModelSil key="sil">
                                        {
                                            block
                                            && block.projectDevice
                                            && getModelSil(block.projectDevice, subsystem.architecturalConstraints, lang)
                                        }
                                    </ModelSil>,
                                ]))
                            }
                        </BlockWrapper>
                    ))
                }
            </ModelWrapper>
        </BlockContent>
    )
}
export default Model
